if (!customElements.get('vv-motion')) customElements.define('vv-motion', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    this.image = this.querySelector('img');
    this.button = this.querySelector('button');
    this.preference = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.preference.matches;
    this.update = () => {
      const animate = this.visible && !this.paused;
      const source = animate ? this.image.dataset.gif : this.image.dataset.poster;
      if (this.image.getAttribute('src') !== source) this.image.src = source;
      this.button.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
      this.button.setAttribute('aria-pressed', String(!this.paused));
    };
    this.button.addEventListener('click', () => { this.paused = !this.paused; this.update(); });
    this.onPreference = () => { this.paused = this.preference.matches; this.update(); };
    this.preference.addEventListener('change', this.onPreference);
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); });
    this.observer.observe(this);
    this.button.hidden = false;
    this.update();
  }
  disconnectedCallback() { this.observer?.disconnect(); this.preference?.removeEventListener('change', this.onPreference); this.initialized = false; }
});
